import React from "react";
import "../assets/css/Contact.css";

const Contact = () => {
    return (
        <div className="contact-page">

            {/* ================= HERO ================= */}
            <section className="contact-hero">
                <div className="contact-hero-content">
                    <h1 className="contact-hero-title">
                        Let’s Build Your Real Estate Future Together
                    </h1>
                    <p className="contact-hero-text">
                        Whether you’re a learner, a channel partner, or a business collaborator -
                        Samriddhi Gurukul is here to guide you every step of the way.
                    </p>
                </div>
            </section>

           

            {/* ================= INFO + FORM ================= */}
            <section className="contact-main">
                <div className="contact-container">

                    {/* LEFT INFO */}
                    <div className="contact-info">
                        <h2>Get in Touch</h2>

                        <div className="contact-info-item">
                            <span>📍</span>
                            <p>
                                407, Navale Icon, Navale Bridge,<br />
                                Vadgaon BK, Pune – 411041
                            </p>
                        </div>

                        <div className="contact-info-item">
                            <span>📞</span>
                            <p>+91 97306 10099 / 95033 70099</p>
                        </div>

                        <div className="contact-info-item">
                            <span>✉️</span>
                            <p>contact@samriddhigurukul.com</p>
                        </div>

                        <div className="contact-info-item">
                            <span>🕒</span>
                            <p>10:00 AM – 6:30 PM</p>
                            <p>Monday Weekoff</p>
                        </div>
                    </div>

                    {/* RIGHT FORM */}
                    <div className="contact-form-box">
                        <h2>Send Us a Message</h2>

                        <form className="contact-form">
                            <input type="text" placeholder="Full Name" required />
                            <input type="email" placeholder="Email Address" required />
                            <input type="tel" placeholder="Phone Number" required />

                            <select required>
                                <option value="">Select Enquiry Type</option>
                                <option>Course Enquiry</option>
                                <option>Franchise Opportunity</option>
                                <option>Events & Webinars</option>
                                <option>Corporate Collaboration</option>
                                <option>General Query</option>
                            </select>

                            <textarea placeholder="Your Message" rows="4"></textarea>

                            <button type="submit" className="contact-submit-btn">
                                Submit Enquiry →
                            </button>
                        </form>
                    </div>

                </div>
            </section>

            {/* ================= ASSURANCE ================= */}
            <section className="contact-assurance">
                <div className="contact-assurance-grid">
                    <div>
                        ⚡ <strong>Quick Response</strong>
                        <p>We respond within 24 working hours</p>
                    </div>
                    <div>
                        🔒 <strong>100% Privacy</strong>
                        <p>Your information is safe with us</p>
                    </div>
                    <div>
                        🤝 <strong>Dedicated Support</strong>
                        <p>Guidance from real estate experts</p>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default Contact;
